import { Box as ChakraBox } from '@chakra-ui/react';
import styled from 'styled-components';

export const StyledBox = styled(ChakraBox)`
  background-color: ${props => props.theme.navbar.background};
  color: ${props => props.theme.input.color};
`;
